import type { PassTemplateMeta } from '../../../../store/types/pass';

const toField = (f: { id?: string; label?: string; defaultValue?: string } | null | undefined) => ({
  id: f?.id || '',
  label: f?.label || '',
  default_value: f?.defaultValue || '',
});

/** Map a getPassTemplate API response into the PassTemplateMeta shape used by the pass show endpoint. */
export const buildTemplateMeta = (
  data: { id: string; attributes: Record<string, unknown> }
): PassTemplateMeta => {
  const attrs = data.attributes;
  const fields = attrs.fields as Record<string, Record<string, { id?: string; label?: string; defaultValue?: string } | null>> | undefined;
  const colors = attrs.colors as Record<string, string> | undefined;

  return {
    name: (attrs.name as string) || '',
    uuid: data.id,
    template_type: (attrs.templateType as string) || '',
    entity_id: '',
    central_title: (attrs.centralTitle as string) || '',
    description: (attrs.description as string) || '',
    transit_type: (attrs.transitType as string) || '',
    header: {
      header_one: toField(fields?.header?.one),
      header_two: toField(fields?.header?.two),
      header_three: toField(fields?.header?.three),
    },
    primary: {
      primary_one: toField(fields?.central?.one),
      primary_two: toField(fields?.central?.two),
    },
    secondary: {
      sec_one: toField(fields?.details?.one),
      sec_two: toField(fields?.details?.two),
      sec_three: toField(fields?.details?.three),
    },
    auxiliary: {
      aux_one: toField(fields?.details?.four),
      aux_two: toField(fields?.details?.five),
      aux_three: toField(fields?.details?.six),
    },
    back_fields: {
      back_one: toField(fields?.back?.one),
      back_two: toField(fields?.back?.two),
      back_three: toField(fields?.back?.three),
      back_four: toField(fields?.back?.four),
      back_five: toField(fields?.back?.five),
    },
    logo_image: '',
    icon_image: '',
    banner_image: '',
    google_banner_image: '',
    thumbnail_image: '',
    text_color: colors?.text || '',
    background_color: colors?.background || '',
    label_color: colors?.label || '',
    apple_app_link: [],
    google_app_link: { play_store_url: '', package_name: '', web_app_url: '', display_text: '' },
    chosen_google_logo: (attrs.chosenGoogleLogo as 'icon' | 'wide_logo') || 'icon',
    watermark: {},
    apple_banner_watermark: {},
    google_banner_watermark: {},
  } as PassTemplateMeta;
};
